export default __webpack_public_path__ + "static/media/AlertError.98f89395.svg";